import { CSpinner } from '@coreui/react';
import React from 'react';
import './ArsLoader.scss';

const ArsLoader = () => {
  return <div id="ars-loader">
    <CSpinner color="light" />
    <p>
      <span className="loader-text">Saving data</span>
      ...
    </p>
  </div>
}

export default ArsLoader;
